import { render, staticRenderFns } from "./badmintonBlockList.vue?vue&type=template&id=bd03db86&"
import script from "./badmintonBlockList.vue?vue&type=script&lang=js&"
export * from "./badmintonBlockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports